"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryTerm = void 0;
/**
 * @description Delivery terms dropdown list
 */
var DeliveryTerm;
(function (DeliveryTerm) {
    DeliveryTerm["COST_AND_FREIGHT"] = "COST_AND_FREIGHT";
    DeliveryTerm["COST_INSURANCE_FREIGHT"] = "COST_INSURANCE_FREIGHT";
    DeliveryTerm["CARRIAGE_AND_INSURANCE_PAID_TO"] = "CARRIAGE_AND_INSURANCE_PAID_TO";
    DeliveryTerm["CARRIAGE_PAID_TO"] = "CARRIAGE_PAID_TO";
    DeliveryTerm["DELIVERED_AT_TERMINAL"] = "DELIVERED_AT_TERMINAL";
    DeliveryTerm["DELIVERED_AT_PLACE"] = "DELIVERED_AT_PLACE";
    DeliveryTerm["DELIVERED_DUTY_PAID"] = "DELIVERED_DUTY_PAID";
    DeliveryTerm["EX_WORKS"] = "EX_WORKS";
    DeliveryTerm["FREE_ALONGSIDE_SHIP"] = "FREE_ALONGSIDE_SHIP";
    DeliveryTerm["FREE_CARRIER"] = "FREE_CARRIER";
    DeliveryTerm["FREE_ON_BOARD"] = "FREE_ON_BOARD";
})(DeliveryTerm = exports.DeliveryTerm || (exports.DeliveryTerm = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsaXZlcnktdGVybS5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3JmcS90eXBlcy9kZWxpdmVyeS10ZXJtLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUg7O0dBRUc7QUFDSCxJQUFZLFlBWVg7QUFaRCxXQUFZLFlBQVk7SUFDdEIscURBQXFDLENBQUE7SUFDckMsaUVBQWlELENBQUE7SUFDakQsaUZBQWlFLENBQUE7SUFDakUscURBQXFDLENBQUE7SUFDckMsK0RBQStDLENBQUE7SUFDL0MseURBQXlDLENBQUE7SUFDekMsMkRBQTJDLENBQUE7SUFDM0MscUNBQXFCLENBQUE7SUFDckIsMkRBQTJDLENBQUE7SUFDM0MsNkNBQTZCLENBQUE7SUFDN0IsK0NBQStCLENBQUE7QUFDakMsQ0FBQyxFQVpXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBWXZCIn0=